type CanEditOrganisationAfterDeliveryInput = {
  isFeatureEnabled: boolean;
  isShipper: boolean;
  isGuest: boolean;
  isOffPlatform: boolean;
  isQuickRequest: boolean;
  requestStatus?: string;
  editOtherShipments: boolean;
};

export function canEditOrganisationAfterDelivery({
  isFeatureEnabled,
  isShipper,
  isGuest,
  isOffPlatform,
  isQuickRequest,
  requestStatus,
  editOtherShipments,
}: CanEditOrganisationAfterDeliveryInput): boolean {
  if (!isFeatureEnabled) return false;
  if (!isShipper || isGuest || isOffPlatform || isQuickRequest || !editOtherShipments) return false;
  if (requestStatus === "Canceled" || requestStatus === "Auto canceled") return false;
  return requestStatus === "Delivered";
}
